import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
// import Layout from "@/layout";


export const constantRoutes = [
  {
    path: "/login",
 
    component: () => import("@/views/login/index"),
  
  },

  {
    path: "/",
    component: () => import("@/views/nextApp"),
    hidden: true,
  },
 

  

  
  // 404 page must be placed at the end !!!
  // { path: "*", redirect: "/404", hidden: true },
];
//异步挂载的路由
//动态需要根据权限加载的路由表
export const asyncRoutes = []

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

//全局前置守卫
router.beforeEach(async (to, from, next) => {
	console.log('to-from', to, from)
  if (process.env.NODE_ENV === 'test' ||process.env.NODE_ENV === 'development' ) {
    // 测试环境and本地环境
    var hostname = window.location.hostname;
      console.log(hostname); // 输出：例如 example.com
      if(hostname ==='test-sepadmin.ikalaok.com'){
        window.location.href = process.env.VUE_APP_MAIN + '/#/login';
      }else{
        console.log('测试放行新域名--------')
        next()
      }
  } else {
        // 正式环境
        var hostname = window.location.hostname;
        console.log(hostname); // 输出：例如 example.com
        if( hostname ==='sep-admin.ikalaok.com' ){
          window.location.href = process.env.VUE_APP_MAIN + '/#/login';
        }else{
          console.log('正式放行--------')
          next()
        }
}


})

export default router;
